import AdaptiveImage from "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/logo-close.png","uri@2x": __webpack_public_path__ + "static/media/logo-close.png","uri@3x": __webpack_public_path__ + "static/media/logo-close.png",
    width: 35,
    height: 60
});